import {
  adminClient,
  oidcClient,
  organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { env } from "../../env";

export const authClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_BASE_URL,
  plugins: [adminClient(), organizationClient(), oidcClient()],
});

export const { signIn, signOut } = authClient;

export const useSession = () => {
  const baseResult = authClient.useSession();

  return {
    ...baseResult,
    status: baseResult.data
      ? ("authenticated" as const)
      : baseResult.isPending
        ? ("loading" as const)
        : ("unauthenticated" as const),
  };
};
